<template>
  <div class="list-root">
    <query-condition-box>
      <el-form
        :inline="true"
        size="small"
        :model="searchParams"
        class="demo-form-inline"
      >
        <el-row>
          <el-col :span="24">
            <datePicker
              :setDate="setDate"
              @changeDate="changeDate"
            ></datePicker>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="状态：">
              <el-radio-group v-model="searchParams.status" size="small">
                <el-radio-button
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.name }}</el-radio-button
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model.trim="searchParams.title"
                style="width: 200px"
                placeholder="请输入文章名称"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model.trim="searchParams.uploader"
                style="width: 200px"
                placeholder="请输入上传人用户名"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="searchClick"
                >查询</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="exportExcel"
                >导出</el-button
              >
            </el-form-item>
            <el-form-item
              style="float: right !important; margin-right: 0 !important"
            >
              <el-button
                type="primary"
                icon="el-icon-upload2"
                @click="goUploadRes"
                >新建文章
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </query-condition-box>
    <div class="result-container">
      <xkw-table v-loading="loading" :data="tableList" v-model="tableName">
        <el-table-column label="文章名称"
          ><template v-slot="scope">
            <el-link
              style="color: #606266"
              v-if="scope.row.status === 2"
              type="primary"
              :underline="false"
              @click="openUrl(scope.row)"
              >{{ scope.row.title }}
            </el-link>
            <span v-if="scope.row.status !== 2">{{ scope.row.title }}</span>
          </template></el-table-column
        >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="pv"
          label="浏览量"
          width="200"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="createTime"
          label="上传时间"
          width="200"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="uploader"
          label="上传人"
          width="200"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          width="100"
          label="状态"
          prop="status"
          ><template slot-scope="{ row }"
            ><span>{{
              row.status == 1
                ? "待审核"
                : row.status == 0
                ? "草稿中"
                : row.status == 2
                ? "已通过"
                : row.status == 4 || row.status == 3
                ? "退稿"
                : ""
            }}</span>
            <i
              v-if="row.status === 4 || row.status === 3"
              class="question-icon"
              @click="showRecycleResult(row)"
            ></i> </template
        ></el-table-column>
        <el-table-column align="center" label="操作" width="200">
          <template v-slot="{ row }">
            <el-link
              :underline="false"
              v-if="row.status === 2 || row.status === 1 || row.status === 5"
              @click="detail(row)"
              type="primary"
              >&nbsp;详情&nbsp;
            </el-link>
            <el-link
              :underline="false"
              v-if="row.status === 0 || row.status === 1"
              @click="editResource(row)"
              type="primary"
              >&nbsp;编辑&nbsp;
            </el-link>
            <el-link
              :underline="false"
              v-if="row.status === 0"
              @click="del(row.id)"
              type="primary"
              >&nbsp;删除&nbsp;
            </el-link>
          </template>
        </el-table-column>
      </xkw-table>
      <el-pagination
        v-show="total !== null && total !== 0"
        background
        style="text-align: right; padding: 10px"
        :current-page.sync="searchParams.pageIndex"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <auth-dialog
      :dialog-visible.sync="auth.flag"
      :tip-type="auth.tipType"
    ></auth-dialog>
  </div>
</template>
<script>
import api from "../../../assets/js/api";
import { isOpenPermissionDialog, objectToQueryString } from "@/assets/js/utils";
import AuthDialog from "@/components/auth-dialog.vue";
import shopCenterConst from "@/assets/js/shopCenterConst";
import datePicker from "@/components/common/date-picker.vue";
export default {
  components: { datePicker, AuthDialog },
  data() {
    return {
      setDate: {}, // 时间控件的时间段 默认传空对象即可
      auth: {
        flag: false,
        tipType: null,
      },
      page: 1,
      tableList: [],
      created: "",
      dialogVisible: false,
      loading: false,
      tableName: "文章列表",
      total: 0,
      timeRadio: "近7天",
      searchParams: {
        time: "month",
        startTime: "",
        endTime: "",
        status: -1,
        providerId: this.$store.state.user.userInfo.shopId,
        title: "",
        uploader: "",
        pageSize: 10,
        pageIndex: 1,
      },
      statusList: [
        { id: -1, name: "不限" },
        { id: 0, name: "草稿中" },
        { id: 1, name: "待审核" },
        { id: 2, name: "已通过" },
        // { id: 3, name: "已下架" },
        { id: 4, name: "退稿" },
      ],
    };
  },
  created() {
    if (this.$route.params.pageIndex) {
      this.searchParams.pageIndex = this.$route.params.pageIndex;
    }
  },
  mounted() {
    // this.setTime();
    if (this.$route.params.pageIndex) {
      this.searchParams.startTime = this.$route.params.from;
      this.searchParams.endTime = this.$route.params.to;
      this.searchParams.time = this.$route.params.time;
      this.searchParams.status = this.$route.params.status;
      this.searchParams.title = this.$route.params.title;
      this.searchParams.pageIndex = this.$route.params.pageIndex;
      // 设置时间控件的时间段
      this.setDate = {
        startTime: this.$route.params.from,
        endTime: this.$route.params.to,
        timeAlias: this.$route.params.time,
      };
    }
    this.getTableList();
  },
  methods: {
    openUrl(row) {
      window.open(`//news.zxxk.com/article/${row.id}.html`);
    },
    changeDate(e) {
      this.searchParams.startTime = e.startTime;
      this.searchParams.endTime = e.endTime;
      this.searchParams.time = e.timeAlias;
    },
    async exportExcel() {
      if (!this.searchParams.startTime) {
        this.$message.error("请选择开始时间");
        return;
      }
      if (!this.searchParams.endTime) {
        this.$message.error("请选择结束时间");
        return;
      }
      let _that = this;
      _that.searchParams.pageIndex = 1;
      _that.setFromToTime();
      const tableList = await _that.$axios.post(
        api.shopResource.getArticleList,
        this.searchParams
      );
      if (tableList.list == null || tableList.totalCount <= 0) {
        _that.$message.warning("无数据");
        return;
      } else if (tableList.totalCount >= shopCenterConst.excel.maxNum) {
        _that.$message.warning(shopCenterConst.excel.tip);
        return;
      }

      window.open(
        api.shopResource.exportArticleList +
          "?" +
          objectToQueryString(this.searchParams)
      );
    },
    //删除
    async del(id) {
      //  auth start;
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1 || type === 3) {
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      //  auth end;
      let _that = this;
      this.$confirm("是否确定删除当前文章?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const isSuc = await _that.$axios.get(api.shopResource.delArticle, {
            articleId: id,
          });
          if (isSuc.valid && isSuc.result) {
            _that.$message.success("删除成功");
            await _that.searchClick();
          } else {
            _that.$message.error("删除失败");
          }
        })
        .catch(() => {});
    },
    //上下架
    async updateStatus(id, status) {
      let _that = this;
      var message = "上架";
      if (status == 3) {
        message = "下架";
      }
      this.$confirm("是否确定" + message + "当前文章?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const isSuc = await this.$axios.post(api.shopResource.updateArticle, {
            id: id,
            status: status,
          });
          if (isSuc.valid) {
            if (isSuc.result) {
              this.$message({
                type: "success",
                message: message + "成功!",
              });
              _that.searchClick();
            } else {
              this.$message({
                type: "error",
                message: message + "失败!",
              });
            }
          }
        })
        .catch(() => {});
    },
    setTime() {
      let timeType = this.searchParams.time;
      var nowData = new Date();
      var startTime = new Date();
      if (timeType == "yesterday") {
        startTime = new Date(new Date().setDate(new Date().getDate() - 1));
      } else if (timeType == "week") {
        startTime = new Date(new Date().setDate(new Date().getDate() - 7));
      } else if (timeType == "month") {
        startTime = new Date(new Date().setMonth(new Date().getMonth() - 1));
      } else if (timeType == "threeMonthes") {
        startTime = new Date(new Date().setMonth(new Date().getMonth() - 3));
      } else if (timeType == "year") {
        startTime = new Date(new Date().setYear(new Date().getFullYear() - 1));
      }
      if (this.searchParams.startTime != null) {
        let month = startTime.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        let day = startTime.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        this.searchParams.startTime =
          startTime.getFullYear() + "-" + month + "-" + day;
      }
      if (this.searchParams.endTime != null) {
        let month = nowData.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        let day = nowData.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        this.searchParams.endTime =
          nowData.getFullYear() + "-" + month + "-" + day;
      }
    },
    setCookie(name, value, daysToLive) {
      let cookie = name + "=" + encodeURIComponent(value);
      if (typeof daysToLive == "number") {
        cookie += ";max-age=" + daysToLive * 60 * 60 * 24;
      }
      cookie += ";Path=" + escape("/");
      document.cookie = cookie;
    },
    async goUploadRes() {
      //  auth start;
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1 || type === 3) {
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      //  auth end;
      await this.$router.push({
        name: "resource-article-upload",
        params: {
          time: this.searchParams.time,
          from: this.searchParams.startTime,
          to: this.searchParams.endTime,
          status: this.searchParams.status,
          pageIndex: this.searchParams.pageIndex,
          title: this.searchParams.title,
        },
      });
    },
    // 资源详情
    detail(row) {
      //  auth start;
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1 || type === 3) {
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      //  auth end;
      this.$router.push({
        name: "resource-article-upload",
        params: {
          time: this.searchParams.time,
          from: this.searchParams.startTime,
          to: this.searchParams.endTime,
          status: this.searchParams.status,
          pageIndex: this.searchParams.pageIndex,
          title: this.searchParams.title,
        },
        query: {
          articleId: row.id,
          operationType: 2, // 1 编辑 2 查看
        },
      });
    },
    // 查看资源
    showRecycleResult(row) {
      this.$confirm(row.description, "退稿原因", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      });
    },
    // 编辑资源
    async editResource(row) {
      //  auth start;
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1 || type === 3) {
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      //  auth end;
      await this.$router.push({
        name: "resource-article-upload",
        params: {
          time: this.searchParams.time,
          from: this.searchParams.startTime,
          to: this.searchParams.endTime,
          status: this.searchParams.status,
          pageIndex: this.searchParams.pageIndex,
          title: this.searchParams.title,
        },
        query: {
          articleId: row.id,
          operationType: 1, // 1 编辑 2 查看
        },
      });
    },
    //搜索按钮
    searchClick() {
      if (!this.searchParams.startTime) {
        this.$message.error("请选择开始时间");
        return;
      }
      if (!this.searchParams.endTime) {
        this.$message.error("请选择结束时间");
        return;
      }
      // 将查询时间段 同步给时间控件（针对时间控件中时间段不完整的情况）
      this.setDate = {
        startTime: this.searchParams.startTime,
        endTime: this.searchParams.endTime,
        timeAlias: this.searchParams.time,
      };
      this.searchParams.pageIndex = 1;
      this.getTableList();
    },
    //获取列表
    async getTableList() {
      this.loading = true;
      this.setFromToTime();
      const tableList = await this.$axios.post(
        api.shopResource.getArticleList,
        this.searchParams
      );
      this.tableList = tableList.list;
      this.total = tableList.totalCount;
      this.loading = false;
    },
    //设置时间控件
    setFromToTime() {
      if (this.searchParams.startTime == null) {
        this.$message.error("请选择开始时间！");
        return;
      }
      if (this.searchParams.endTime == null) {
        this.$message.error("请选择结束时间！");
        return;
      }
      if (this.searchParams.startTime.indexOf(" ") === -1) {
        this.searchParams.startTime = this.searchParams.startTime + " 00:00:00";
      }
      if (this.searchParams.endTime.indexOf(" ") === -1) {
        this.searchParams.endTime = this.searchParams.endTime + " 23:59:59";
      }
    },
    // 修改当前页
    handleCurrentChange(pageIndex) {
      this.searchParams.pageIndex = pageIndex;
      //请求
      this.getTableList();
    },
  },
};
</script>
<style lang="scss" scoped>
//::v-deep .has-gutter .el-table__cell:first-of-type {
//  text-align: left !important;
//}
.question-icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  background-image: url(../../../assets/images/question-circle.png);
  background-size: contain;
  background-repeat: no-repeat;
  vertical-align: middle;
  cursor: pointer;
  margin-bottom: 2px;
  margin-left: 2px;
}

.result-container {
  padding: 20px;
  background: #fff;
  border-radius: 5px;
}

.title {
  margin-bottom: 10px;
}

.property {
  font-size: 14px;
  color: #666;
  margin-right: 20px;
}

.free {
  color: #5a83ff;
}

::v-deep .el-table thead {
  color: #333 !important;
}
</style>
<style lang="css">
.price-input .el-input__inner {
  width: 150px;
}

.overflow {
  width: 80%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  height: 25px;
  line-height: 25px;
  vertical-align: middle;
}
</style>
